// @ts-nocheck
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/lib/query-client";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { TwilioDeviceProvider } from "@/components/calls/twilio-device-provider";
import { Route, Switch } from "wouter";
import LeadDetailContent from "@/components/leads/lead-detail-content";

/**
 * Stripped-down lead detail popup. No Layout chrome.
 * Route: /lead-popup/:id
 */
export function LeadPopupPage() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <TwilioDeviceProvider>
          <div className="min-h-screen bg-background p-4">
            <Switch>
              <Route path="/lead-popup/:id" component={LeadDetailContent} />
            </Switch>
          </div>
          <Toaster />
        </TwilioDeviceProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
}
